import { QuestionRoomCapacity as QuestionCommonRoomCapacity } from "@/components/features/items/edit/room/_shared/ui/_components/capacity/capacity";

import { useRoomCapacity } from "./hooks";

export const QuestionRoomCapacity = () => {
	const {
		isEdited,
		hasError,
		capacityPeopleMaximum,
		onSetCapacityPeopleMaximum, //
		capacityAdultMaximum,
		onSetCapacityAdultMaximum,
		capacityKidsMaximum,
		onSetCapacityKidsMaximum,
		isKidsUnavailable,
		onSetIsKidsUnavailable,
	} = useRoomCapacity();

	return (
		<QuestionCommonRoomCapacity
			isEdited={isEdited}
			hasError={hasError}
			capacityPeopleMaximum={capacityPeopleMaximum}
			onSetCapacityPeopleMaximum={onSetCapacityPeopleMaximum}
			capacityAdultMaximum={capacityAdultMaximum}
			onSetCapacityAdultMaximum={onSetCapacityAdultMaximum}
			capacityKidsMaximum={capacityKidsMaximum}
			onSetCapacityKidsMaximum={onSetCapacityKidsMaximum}
			isKidsUnavailable={isKidsUnavailable}
			onSetIsKidsUnavailable={onSetIsKidsUnavailable}
		/>
	);
};

QuestionRoomCapacity.displayName = "QuestionRoomCapacity";
